@let config = resolvedConfig();

<ftr-placeholder-state
  [message]="message()"
  [title]="title()"
  [size]="size()"
  [icon]="config.icon"
  [iconColor]="config.iconColor"
  [illustration]="config.illustration"
>
  <ng-content />
</ftr-placeholder-state>
